// extracted by mini-css-extract-plugin
export default {"formInput":"YourName_formInput__8BYfo","inputs":"YourName_inputs__47D3w"};